var _path, _path2, _path3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoteCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 9.91671V12.75H28.3337V9.91671C28.3337 9.16526 28.0351 8.44459 27.5038 7.91324C26.9724 7.38188 26.2518 7.08337 25.5003 7.08337H8.50033C7.74888 7.08337 7.02821 7.38188 6.49686 7.91324C5.9655 8.44459 5.66699 9.16526 5.66699 9.91671Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 7.08333H25.5003C26.2518 7.08333 26.9724 7.38184 27.5038 7.9132C28.0351 8.44455 28.3337 9.16522 28.3337 9.91667V12.75H5.66699V9.91667C5.66699 9.16522 5.9655 8.44455 6.49686 7.9132C7.02821 7.38184 7.74888 7.08333 8.50033 7.08333H11.3337M22.667 7.08333V4.25M22.667 7.08333H11.3337M11.3337 7.08333V4.25M5.66699 13.4583V26.9167C5.66699 27.6681 5.9655 28.3888 6.49686 28.9201C7.02821 29.4515 7.74888 29.75 8.50033 29.75H25.5003C26.2518 29.75 26.9724 29.4515 27.5038 28.9201C28.0351 28.3888 28.3337 27.6681 28.3337 26.9167V13.4583",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1198 26.0333L18.6492 18.1198L23.4818 23.3286L17.3691 29H19.5745L24.5021 24.4282L25.6017 23.408L24.5815 22.3084L19.7488 17.0996L18.7286 16L17.6289 17.0202L9.09962 24.9337L8 25.9539L9.02022 27.0535L10.8262 29H12.8723L10.1198 26.0333Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.8009,
    y1: 25.1765,
    x2: 17.7398,
    y2: 21.177,
    stroke: "black",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5622,
    y1: 25.915,
    x2: 14.5627,
    y2: 25.976,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteCalendar);
export default __webpack_public_path__ + "static/media/VoteCalendar.f6dfaad6834be8f105a21c960e1d364d.svg";
export { ForwardRef as ReactComponent };